export default {
  validationLoading: (state) => state.validationLoading,
  validationError: (state) => state.validationError,
  validationSuccess: (state) => state.validationSuccess,
};
